import React from 'react'
import { RichUtils } from 'draft-js'
import ToolbarIcon from './toolbaricon'
import { INLINE_STYLE } from 'draft-js-utils'
import cx from 'classnames'
import Icon from 'components/shared/Icon'

export const INLINE_STYLES = [
  { icon: 'icon-format-bold', style: INLINE_STYLE.BOLD },
  { icon: 'icon-format-italic', style: INLINE_STYLE.ITALIC },
  { icon: 'icon-format-underline', style: INLINE_STYLE.UNDERLINE }
]

const InlineToolbar = ({ show, editorState, onToggle, onLinkEdit, onLinkRemove, position }) => {
  if (!show) return null
  const currentStyle = editorState.getCurrentInlineStyle()
  const containsLink = RichUtils.currentBlockContainsLink(editorState)
  return (
    <div
      className='toolbar inline active'
      style={position}
    >
      <ul className='toolbar-icons'>
        {INLINE_STYLES.map(type =>
          <ToolbarIcon
            key={type.label || type.icon}
            active={currentStyle.has(type.style)}
            label={type.label}
            icon={type.icon}
            onToggle={onToggle}
            style={type.style}
          />
        )}
        <li
          key='icon-link-variant'
          className={cx('toolbar-icon', { active: containsLink })}
          onMouseDown={onLinkEdit}
        >
          <Icon name='icon-link-variant' className='w7 mv2' />
        </li>
        <LinkRemove {...{ containsLink, onLinkRemove }} />
      </ul>
    </div>
  )
}

const LinkRemove = ({ containsLink, onLinkRemove }) => !containsLink
  ? null
  : (
    <li
      className='toolbar-icon'
      onMouseDown={onLinkRemove}
    >
      <Icon name='icon-close' />
    </li>
    )

export default InlineToolbar
